/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

type Props = {
  title?: React.ReactNode | null;
  subtitle?: React.ReactNode;
  numSubtitleLines?: number;
};

const styles = {
  subtitle: (numSubtitleLines: number) => css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: ${numSubtitleLines};
    -webkit-box-orient: vertical;
  `,
};

const KeyInformationDetailsItem = ({ title, subtitle, numSubtitleLines }: Props) => {
  if (!title) return null;

  return (
    <div>
      <Typography2 variant="subtitleLarge" component="div">
        {title}
      </Typography2>
      <Typography2
        variant="bodySecondary"
        component="div"
        color="supportText"
        css={numSubtitleLines && styles.subtitle(numSubtitleLines)}
      >
        {subtitle}
      </Typography2>
    </div>
  );
};

export default KeyInformationDetailsItem;
